import { defineComponent as A, openBlock as t, createElementBlock as e, mergeProps as V, unref as o, renderSlot as u, createElementVNode as l, createCommentVNode as p } from "vue";
import { useScalarIcon as i } from "../hooks/useScalarIcon.js";
const m = { key: 0 }, Z = { key: 1 }, g = { key: 2 }, h = { key: 3 }, M = { key: 4 }, f = { key: 5 }, k = {
  name: "ScalarIconNumberSquareSeven"
}, _ = /* @__PURE__ */ A({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const H = r, { bind: s, weight: n } = i(H);
    return (d, a) => (t(), e("svg", V({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(s)), [
      u(d.$slots, "default"),
      o(n) === "bold" ? (t(), e("g", m, a[0] || (a[0] = [
        l("path", { d: "M208,28H48A20,20,0,0,0,28,48V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V48A20,20,0,0,0,208,28Zm-4,176H52V52H204ZM92,88a12,12,0,0,1,12-12h48a12,12,0,0,1,11.28,16.1l-32,88a12,12,0,0,1-22.56-8.2L134.87,100H104A12,12,0,0,1,92,88Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (t(), e("g", Z, a[1] || (a[1] = [
        l("path", {
          d: "M216,48V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208A8,8,0,0,1,216,48Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208ZM158.55,83.41a8,8,0,0,1,1,7.32l-32,88A8,8,0,0,1,120,184a7.9,7.9,0,0,1-2.73-.48,8,8,0,0,1-4.79-10.25L140.58,96H104a8,8,0,0,1,0-16h48A8,8,0,0,1,158.55,83.41Z" }, null, -1)
      ]))) : o(n) === "fill" ? (t(), e("g", g, a[2] || (a[2] = [
        l("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM159.52,90.73l-32,88A8,8,0,0,1,120,184a7.9,7.9,0,0,1-2.73-.48,8,8,0,0,1-4.79-10.25L140.58,96H104a8,8,0,0,1,0-16h48a8,8,0,0,1,7.52,10.73Z" }, null, -1)
      ]))) : o(n) === "light" ? (t(), e("g", h, a[3] || (a[3] = [
        l("path", { d: "M208,34H48A14,14,0,0,0,34,48V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V48A14,14,0,0,0,208,34Zm2,174a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V48a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2ZM156.91,84.56a6,6,0,0,1,.73,5.49l-32,88A6,6,0,0,1,120,182a6.15,6.15,0,0,1-2-.36,6,6,0,0,1-3.59-7.69L143.43,94H104a6,6,0,0,1,0-12h48A6,6,0,0,1,156.91,84.56Z" }, null, -1)
      ]))) : o(n) === "regular" ? (t(), e("g", M, a[4] || (a[4] = [
        l("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208ZM158.55,83.41a8,8,0,0,1,1,7.32l-32,88A8,8,0,0,1,120,184a7.9,7.9,0,0,1-2.73-.48,8,8,0,0,1-4.79-10.25L140.58,96H104a8,8,0,0,1,0-16h48A8,8,0,0,1,158.55,83.41Z" }, null, -1)
      ]))) : o(n) === "thin" ? (t(), e("g", f, a[5] || (a[5] = [
        l("path", { d: "M208,36H48A12,12,0,0,0,36,48V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V48A12,12,0,0,0,208,36Zm4,172a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V48a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4ZM155.28,85.71a4,4,0,0,1,.48,3.66l-32,88A4,4,0,0,1,120,180a4.12,4.12,0,0,1-1.37-.24,4,4,0,0,1-2.39-5.13L146.29,92H104a4,4,0,0,1,0-8h48A4,4,0,0,1,155.28,85.71Z" }, null, -1)
      ]))) : p("", !0)
    ], 16));
  }
});
export {
  _ as default
};
